import Services from "@/services/utils/Services";

class ServicesPortal extends Services {
  constructor(endpoint) {
    super(process.env.VUE_APP_ROOT_API_PORTAL + endpoint);
  }
}

export default ServicesPortal;
